<template>
  <div class="home">
    <!-- 顶部栏 -->
    <div class="head_container">
      <div class="content_width font_size_12 head_content">
        <div class="left">
          <div v-for="(item,index) in headLeftBtn" :key="index" class="btn" @click="handleHeadNavigation(item)">
            {{item.text}}
            <span v-if="index < headLeftBtn.length - 1">|</span>
          </div>
        </div>
        <div class="right">
          <div v-for="(item,index) in headRightBtn" :key="index" class="btn" @click="handleHeadNavigation(item)">
             <svg class="icon_svg" aria-hidden="true">
               <use :xlink:href="item.icon"></use>
             </svg> 
            {{item.text}}
            <span v-if="index < headRightBtn.length - 1">|</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 搜索栏 -->
    <div style="background-color: #fff;">
      <div class="search_container content_width">
        <div class="image_content">
          <img src="@/assets/home/logo.png" class="" alt="logo">
          <img src="@/assets/home/slogan-pc.jpg" class="" alt="logo">
        </div>
        <div class="search_content">
          <div class="tel_content font_size_12">
            <img src="@/assets/home/custom.png" class="" alt="logo">
            24小时咨询热线:
            <a href="tel:027-87893888">027-87893888</a>
          </div>
          <div class="input_content">
            <el-input placeholder="请输入内容" v-model.trim="searchText" class="search_input" prefix-icon="el-icon-search" :placeholder="'搜职称 资料 科目'">
            </el-input>
            <el-button class="search_btn" type="primary" @click="handleSearch">搜索</el-button>
          </div>
          <div class="search_tips font_size_12" v-show="false">
            热门搜索：
            <div v-for="(item,index) in searchTips" :key="index" class="tip">
              {{item}}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 首页顶部广告（与导航栏位置互换，仅首页展示） -->
    <img v-if="currentRouteName === 'home'" v-for="(ad, idx) in topAdList" :key="'topad'+idx" :src="ad.image_url" class="top_ad_img" @click="handleAdClick(ad.link_url)">

    <!-- 导航栏 -->
    <div class="category_container ">
      <div class="category_content content_width">
        <div class="all_category">
          <svg class="icon_svg" aria-hidden="true">
            <use :xlink:href="'#icon-fenlei'"></use>
          </svg> 
          全部分类
          <div class="move_btn" @mouseenter="enterAllCategory"  @mouseleave="leaveAllCategory"></div>

          <div v-if="currentRouteName !== 'home'"  v-show="showNavigation" class="more_category_container">
            <div class="more_category_left">
              <div v-for="(item,index) in navigationLeft" :key="item.nav" class="more_category_left_item" @mouseenter="enterNavigation(item,index)" @mouseleave="leaveNavigation" @click="goChannel(item)" :class="{'active':activeNavIndex === index}">
                <svg class="icon_svg" aria-hidden="true">
                  <use :xlink:href="item.icon"></use>
                </svg>
                {{item.text}}
              </div>
            </div>
            <div class="more_category_right" v-show="showMoreNavigation" @mouseenter="enterMoreNav" @mouseleave="leaveMoreNav">
              <div v-for="(item,index) in activeNav" :key="item.nav" class="more_category_right_item" @click="goChannel(item)">
                {{item.text}}
              </div>
            </div>
          </div>

        </div>
        <div v-for="(item,index) in categoryList" :key="item.nav" class="category_item" @click="handleHeadNavigation(item.nav)">
          {{item.text}}
          <span v-if="index < categoryList.length - 1"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNavigations, getCategories, getBanners } from '@/api'

export default {
  name: 'HomeView',
  components: {
  },
  data() {
    return {
      headLeftBtn: [],
      headRightBtn: [],
      searchTips:[],
      categoryList:[
        {text: '首页',nav:'home'},
      ],
      searchText: '',
      topAdList: [],  // 首页顶部广告（动态可增删）

      currentRouteName: '',  // 当前路由名称
      showNavigation: false,
      showMoreNavigation: false,
      showMoreNavigationTime: null,
      navigationLeft: [],
      moreNavigation: {},
      activeNav:[],
      activeNavIndex: null,
    }
  },
  async created() {
    await this.loadDynamicData()
  },
  mounted() {
    this.currentRouteName = this.$route.name;
    // 监听路由变化
    this.routeWatcher = this.$router.afterEach((to, from) => {
      this.currentRouteName = to.name;
    });
  },
  methods: {
    async loadDynamicData() {
      try {
        const navs = await getNavigations({ nav_type: 'main' })
        if (navs && navs.length) {
          const mapped = navs.filter(n => n.route_path && n.name !== '首页' && n.name !== '关于我们')
          if (mapped.length) {
            this.categoryList = [{text: '首页',nav:'home'}, ...mapped.map(n => ({text: n.name, nav: n.route_path.replace('/','')}))]
          }
        }
      } catch (e) { console.log('主导航加载失败') }

      try {
        // 头部左侧导航
        const leftNavs = await getNavigations({ nav_type: 'head_left' })
        if (leftNavs && leftNavs.length) {
          this.headLeftBtn = leftNavs.map(n => ({
            text: n.name,
            route_path: n.route_path,
            icon: n.icon
          }))
        }
      } catch (e) { console.log('head_left加载失败') }

      try {
        // 头部右侧导航
        const rightNavs = await getNavigations({ nav_type: 'head_right' })
        if (rightNavs && rightNavs.length) {
          this.headRightBtn = rightNavs.map(n => ({
            text: n.name,
            route_path: n.route_path,
            icon: n.icon || '#icon-shejiaotubiao-06'
          }))
        }
      } catch (e) { console.log('head_right加载失败') }

      try {
        const cats = await getCategories()
        if (cats && cats.length) {
          const parents = cats.filter(c => !c.parent_id)
          const children = cats.filter(c => c.parent_id)
          if (parents.length) {
            this.navigationLeft = parents.map(c => ({
              text: c.name,
              nav: c.slug || c.name,
              icon: c.icon || '#icon-zigezheng'
            }))
            const moreNav = {}
            parents.forEach(p => {
              const subs = children.filter(c => c.parent_id === p.id)
              if (subs.length) {
                moreNav[p.slug || p.name] = subs.map(c => ({
                  text: c.name,
                  nav: c.slug || c.name
                }))
              }
            })
            if (Object.keys(moreNav).length) this.moreNavigation = moreNav
          }
        }
      } catch (e) { console.log('分类加载失败') }

      try {
        // 首页顶部广告（动态可增删）
        const topAdBanners = await getBanners({ position: 'home_top_ad' })
        if (topAdBanners && topAdBanners.length) {
          this.topAdList = topAdBanners.map(b => ({ image_url: b.image_url, link_url: b.link_url || '' }))
        }
      } catch (e) { console.log('顶部广告加载失败') }
    },
    handleAdClick(link) {
      if (!link) return
      if (link.startsWith('http://') || link.startsWith('https://')) {
        window.open(link, '_blank')
      } else {
        this.$router.push(link)
      }
    },
    handleSearch(){
      if(!this.searchText){
        return
      }
      this.$router.push({name:'articleList',query:{keyword:this.searchText}});
      this.searchText = '';
    },
    handleHeadNavigation(item){
      // 兼容字符串（旧方式：路由名）和对象（新方式：{route_path}）
      if (typeof item === 'string') {
        this.$router.push({name: item}).catch(() => {})
        return
      }
      if (!item || !item.route_path) return
      const path = item.route_path
      // 特殊指令
      if (path === '#setHome' || path === '#collect') {
        return
      }
      if (path === '#wb') {
        window.open('https://weibo.com/hdfjyw', '_blank')
        return
      }
      // 外部链接
      if (path.startsWith('http://') || path.startsWith('https://')) {
        window.open(path, '_blank')
        return
      }
      // 内部路由
      if (path.startsWith('/')) {
        this.$router.push({ path: path }).catch(() => {})
      }
    },
    // 全部分类下拉项点击跳转（左/右项共用）
    goChannel(item) {
      if (!item) return
      if (item.route_path) {
        if (item.route_path.startsWith('http://') || item.route_path.startsWith('https://')) {
          window.open(item.route_path, '_blank')
        } else {
          this.$router.push({ path: item.route_path }).catch(() => {})
        }
        return
      }
      if (item.nav) {
        this.$router.push('/examChannel/' + item.nav).catch(() => {})
      }
    },

    enterAllCategory(){
      if(this.currentRouteName !== 'home'){
        clearTimeout(this.showMoreNavigationTime);
        this.showNavigation = true;
      }
    },
    leaveAllCategory(){
      this.clearNavigation();
    },
    enterNavigation(item,index) {
      clearTimeout(this.showMoreNavigationTime);
      this.showMoreNavigation = true;
      this.activeNav = this.moreNavigation[item.nav] || [];
      this.activeNavIndex = index;
    },
    leaveNavigation() {
      this.clearNavigation();
    },
    enterMoreNav() {
      clearTimeout(this.showMoreNavigationTime);
    },
    leaveMoreNav() {
      this.clearNavigation();
    },
    clearNavigation(){
      this.showMoreNavigationTime = setTimeout(() => {
        this.showNavigation = false;
        this.showMoreNavigation = false;
        this.activeNavIndex = null;
      }, 100);
    }
  },
}
</script>
<style scoped lang="scss">
.home {
  font-size: 16px;
}
.top_ad_img {
  width: 100%;
  display: block;
  cursor: pointer;
}
.head_container {
  padding: 10px 0;
  background-color: #F0F0F0;
  .head_content{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .btn{
      cursor: pointer;
    }
    .btn:hover{
      color: #007AFF;
    }
    .left{
      display: flex;
      align-items: center;
      span{
        margin: 0px 15px;
      }
    }
    .right{
      display: flex;
      align-items: center;
      .btn{
        display: flex;
        align-items: center;
      }
      span{
        margin: 0px 15px;
      }
      .icon_svg{
        margin-right: 5px;
      }
    }
  }
}

.search_container{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  .image_content{
    display: flex;
    align-items: center;
    img{
      margin-right: 30px;
    }
  }
  .search_content{
    .tel_content{
      display: flex;
      align-items: center;
      img{
        margin-right: 5px;
      }
      a{
        margin-left: 10px;
        font-size: 19px;
        color: #EE4A4A;
        font-weight: 600;
        text-decoration: none;
      }
    }
    .input_content{
      display: flex;
      align-items: center;
      border: 1px solid #005BAC;
      border-radius: 5px;
      .search_input{
        width: 350px;
        ::v-deep input{
          border: none;
        }
      }
      .search_btn{
        background-color: #005BAC;
        border-radius: 0;
        border: none;
        line-height: 16px
      }
    }
    .search_tips{
      display: flex;
      align-items: center;
      margin-left: 5px;
      margin-top: 8px;
      color: #999;
      .tip{
        margin-right: 10px;
        cursor: pointer;
      }
    }
  }
}

.category_container{
    background: linear-gradient(to bottom, #117bda, #01529b);
    font-size: 14px;
    .category_content{
      display: flex;
      align-items: center;
      .all_category{
        display: flex;
        align-items: center;
        padding: 15px 20px;
        width: 210px;
        color: #fff;
        cursor: pointer;
        background-color: #004f96;
        position: relative;
        .icon_svg{
          margin-right: 5px;
        }
        .move_btn{
          position: absolute;
          left: 0;
          top: 0%;
          width: 100%;
          height: 100%;
          z-index: 10;
        }
        .more_category_container{
          display: flex;
          position: absolute;
          top: 100%;
          left: 0;
          height: 300px;
          color: #fff;
          z-index: 9;
          .more_category_left{
            background-color: #004f96;
            height: 100%;
            width: 210px;
            .more_category_left_item{
              padding-left: 20px;
              cursor: pointer;
              text-align: left;
              font-size: 15px;
              display: flex;
              align-items: center;
              height: 16.6%;
              .icon_svg{
                margin-right: 10px;
                font-size: 11px;
              }
            }
            .more_category_left_item:hover{
              background-color: #4DA1EC;
            }
            .active{
              background-color: #4DA1EC;
            }
          }
          .more_category_right{
            height: 100%;
            width: 500px;
            background-color: #4DA1EC;
            display: flex;
            flex-wrap: wrap;
            align-content: flex-start;
            .more_category_right_item{
              margin-left: 20px;
              margin-top: 20px;
              cursor: pointer;
              text-align: left;
              font-size: 13px;
            }
          }
        }
      }
      .category_item{
        color: #fff;
        cursor: pointer;
        padding: 15px 20px;
        position: relative;
        span{
          position: absolute;
          right: 0;
          background-color: #000;
          height: 30px;
          width: 1px;
          transform: scale(0.5) translateY(-20%);
        }
      }
      .category_item:hover{
        background-color: #4DA1EC;
        span{
          background-color: #4DA1EC;
        }
      }
    }
  }

</style>
